import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiJson, authorizedFetch } from "@/utils/fetch";
import type { ApiKeyScope, ApiKeySummary, CreatedApiKey } from "@/types";

export function useApiKeys() {
  return useQuery({
    queryKey: ["api-keys"],
    queryFn: () => apiJson<ApiKeySummary[]>("/api-keys"),
    refetchOnWindowFocus: false,
  });
}

export function useCreateApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      name: string;
      project_id: string;
      scopes: ApiKeyScope[];
    }) =>
      apiJson<CreatedApiKey>("/api-keys", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["api-keys"] });
    },
  });
}

export function useRevokeApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await authorizedFetch(`/api-keys/${id}`, { method: "DELETE" });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["api-keys"] });
    },
  });
}
